import { FC } from "react";
import { Note } from "@contentful/f36-components";
import { GlossaryLocalePair } from "../lib";

interface BadGlossaryLocalesWarningProps {
    badLocales: GlossaryLocalePair[];
}

export const BadGlossaryLocalesWarning: FC<BadGlossaryLocalesWarningProps> = ({ badLocales }) => {
    if (badLocales.length === 0) {
        return null;
    }

    return (
        <Note variant="warning" style={{ width: "100%" }}>
            The following glossary locales are not supported and will not be uploaded:{" "}
            <strong>{badLocales.map(pair => `${pair.source}/${pair.target}`).join(", ")}</strong>
        </Note>
    );
};
